import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import userReducer from "../slice/user/userSlice";
import errorReducer from "../slice/error/errorSlice";
import filterReducer from '../slice/ccheFilter/cachefilterSlice';


const localStorageMiddleware = (store) => (next) => (action) => {
  const result = next(action); // Dispatch the action
  const state = store.getState().filter; // Get the updated filter state

  // Save thedeb current filter state to localStorage
  localStorage.setItem('cacheFilter', JSON.stringify(state));

  return result;
};

export default configureStore({
  reducer: {
    user: userReducer,
    error: errorReducer,
    filter: filterReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, 
    }).concat(localStorageMiddleware)
});
